import React from 'react';
import { Link } from 'react-router-dom';
import AuthenticationService from '../service/AuthenticationService.js';
import brand from '../brand';
import AuthLayout, { PasswordInput, FieldError, apiErrorMessage, finishSignIn, isValidEmail } from '../components/AuthLayout';
import { GoogleClientId, GoogleSignInOption } from '../components/GoogleSignInButton';


class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        const state = (props.location && props.location.state) || {}
        // set by axiosInstance when the server rejects the stored token
        const signedOut = new URLSearchParams((props.location && props.location.search) || '').get('signedOut')
        this.state = {
            usernameOrEmail: state.email || '',
            password: '',
            errorMsg: signedOut === 'disabled' ? 'Your account has been disabled. Please contact the shop.' : '',
            fieldErrors: {},
            isLoading: false,
            notice: state.registered ? 'Your account is ready. Please log in.'
                : state.passwordReset ? 'Your password has been updated. Please log in.'
                : signedOut === 'expired' ? 'You have been signed out. Please log in again.' : ''
        };
    }

    onChangeUserName = (event) => {
        this.setState({
            usernameOrEmail: event.target.value
        })
    }
    onChangePassword = (event) => {
        this.setState({
            password: event.target.value
        })
    }

    login = (event) => {
        event.preventDefault();
        const { usernameOrEmail, password } = this.state
        const fieldErrors = {}
        if (!usernameOrEmail.trim()) {
            fieldErrors.email = 'Please enter your email.'
        } else if (!isValidEmail(usernameOrEmail)) {
            fieldErrors.email = 'Please enter a valid email address.'
        }
        if (!password) {
            fieldErrors.password = 'Please enter your password.'
        }
        this.setState({ fieldErrors, errorMsg: '' })
        if (Object.keys(fieldErrors).length > 0) return

        this.setState({
            isLoading: true
        })

        AuthenticationService.loginApi({ usernameOrEmail: usernameOrEmail.trim(), password }).then(response => {
            if (response.status === 200 && response.data) {
                this.setState({
                    isLoading: false
                })
                finishSignIn(this.props.history, response.data)
            } else {
                this.setState({
                    errorMsg: 'Please enter a valid email and password.',
                    isLoading: false
                })
            }
        }).catch(error => {
            console.log(error.response)
            this.setState({
                errorMsg: apiErrorMessage(error, 'Incorrect email or password.'),
                isLoading: false
            })
        })
    }

    render() {
        return <GoogleClientId>{this.renderPage}</GoogleClientId>
    }

    // googleClientId: undefined while unknown, '' when Google sign-in is off
    renderPage = (googleClientId) => {
        const { usernameOrEmail, password, isLoading, errorMsg, fieldErrors, notice } = this.state
        return (
            <AuthLayout
                title='Welcome back'
                subtitle='Log in to shop, track orders and check out faster.'
                footer={<>New to {brand.name}? <Link className='mv-auth-link' to='/register'>Create an account</Link></>}
            >
                <GoogleSignInOption clientId={googleClientId} text='continue_with' divider='or log in with email'
                    onSuccess={data => finishSignIn(this.props.history, data)}
                    onError={message => this.setState({ errorMsg: message, notice: '' })} />

                <form onSubmit={this.login} className={'mv-auth-form' + (googleClientId !== '' ? ' after-alt' : '')} noValidate>
                    {notice && !errorMsg && <div className='mv-alert mv-alert-success' role='status'>{notice}</div>}
                    {errorMsg && <div className='mv-alert mv-alert-error' role='alert'>{errorMsg}</div>}

                    <div className='mv-field'>
                        <label className='mv-label' htmlFor='login-email'>Email</label>
                        <input
                            id='login-email'
                            className='mv-input'
                            type='email'
                            inputMode='email'
                            autoComplete='email'
                            placeholder='you@example.com'
                            value={usernameOrEmail}
                            onChange={this.onChangeUserName}
                            aria-invalid={fieldErrors.email ? 'true' : undefined}
                            aria-describedby={fieldErrors.email ? 'login-email-error' : undefined}
                        />
                        <FieldError id='login-email-error' message={fieldErrors.email} />
                    </div>

                    <div className='mv-field'>
                        <div className='mv-auth-row'>
                            <label className='mv-label' htmlFor='login-password'>Password</label>
                            <Link className='mv-auth-link' to='/resetPasswod'>Forgot password?</Link>
                        </div>
                        <PasswordInput
                            id='login-password'
                            value={password}
                            onChange={this.onChangePassword}
                            placeholder='Your password'
                            autoComplete='current-password'
                            invalid={!!fieldErrors.password}
                            describedBy={fieldErrors.password ? 'login-password-error' : undefined}
                        />
                        <FieldError id='login-password-error' message={fieldErrors.password} />
                    </div>

                    <button type='submit' className={`mv-btn mv-btn-primary mv-btn-block mv-auth-submit${isLoading ? ' is-busy' : ''}`} disabled={isLoading} aria-busy={isLoading}>
                        {isLoading ? 'Logging in…' : 'Log in'}
                    </button>
                </form>
            </AuthLayout>
        );
    }
}

export default LoginForm;
